import React, { useEffect, useState } from "react";
import { db } from "../../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [columns, setColumns] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const paymentsSnapshot = await getDocs(collection(db, "payments"));
        const paymentsData = paymentsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPayments(paymentsData);

        const total = paymentsData.reduce((sum, payment) => {
          return sum + (parseFloat(payment.amount) || 0);
        }, 0);
        setTotalAmount(total);

        if (paymentsData.length > 0) {
          const allKeys = new Set();
          paymentsData.forEach((payment) => {
            Object.keys(payment).forEach((key) => allKeys.add(key));
          });
          setColumns([...allKeys]);
        }
      } catch (error) {
        console.error("Error fetching payments:", error);
      }
    };

    fetchPayments();
  }, []);

  const containerStyle = {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    background: "#09141b", // Dark background
    color: "#ffffff", // White text
    minHeight: "100vh",
  };

  const headerStyle = {
    textAlign: "center",
    color: "#4caf50", // Green header
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    background: "#1c252b", // Slightly lighter dark background
    borderRadius: "8px",
    overflow: "hidden",
  };

  const thStyle = {
    border: "1px solid #444",
    padding: "8px",
    textAlign: "left",
    textTransform: "capitalize",
    backgroundColor: "#4CAF50", // Green header background
    color: "#ffffff",
  };

  const tdStyle = {
    border: "1px solid #444",
    padding: "8px",
    textAlign: "left",
    color: "#ffffff",
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Admin Payments</h1>
      <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#4caf50" }}>
        Total Amount Received: $
        {totalAmount.toLocaleString("en-US", { minimumFractionDigits: 2 })}
      </h2>
      {payments.length > 0 ? (
        <table style={tableStyle}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col} style={thStyle}>
                  {col.replace(/([A-Z])/g, " $1")}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.id}>
                {columns.map((col) => (
                  <td key={col} style={tdStyle}>
                    {typeof payment[col] === "object" && payment[col]?.seconds
                      ? new Date(payment[col].seconds * 1000).toLocaleString()
                      : payment[col]?.toLocaleString?.() || payment[col] || "N/A"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p style={{ textAlign: "center", marginTop: "20px", color: "#ffffff" }}>
          No payments found.
        </p>
      )}
    </div>
  );
};

export default AdminPayments;
